<template>
  <div>
    <span>{{ this.fromNow }} </span>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "DynamicDateFromNow",

  props: {
    value: String,
    interval: {
      type: Number,
      default: 1000
    }
  },

  data() {
    return {
      fromNow: moment(this.value).fromNow(),
      intervalId: null
    };
  },

  mounted() {
    this.intervalId = setInterval(this.updateFromNow, this.interval);
    this.$watch("value", this.updateFromNow);
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods: {
    updateFromNow() {
      let newFromNow = moment(this.value).fromNow(this.dropFixes);
      if (newFromNow !== this.fromNow) {
        this.fromNow = newFromNow;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Molecules/DynamicDateFromNow.vue